<template>
  <div>
    <Crumbs :list="crumbsList" :title="title"></Crumbs>
    <div id="article">
      <h1 class="title">{{title}}</h1>
      <div class="article-time">{{time}}</div>
      <div class="content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import Crumbs from '@/components/Crumbs.vue'
import {reContent, imgError} from '@/assets/utility'

export default {
  components: { Crumbs },
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      content: '',
      crumbsList: [],
      title: '',
      time: ''
    }
  },
  mounted() {
    this.$axios.post(`currency/getArticleById?id=${this.$route.params.aid}`).then((res)=>{
      if (res) {
        this.title = res.title
        this.time = res.createTime
        this.content = reContent(res.content)
        this.crumbsList = res.columns.reverse()
      }
    })
  },
  methods: {
    imgError(pUrl) {
      imgError(pUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
  @media only screen and (min-width: 768px) {
    #article {
      //margin:  0 rem(225);
      margin-bottom: rem(50);
      padding: rem(50) rem(225);
      //border-top: 21px solid #b50627;
      background-color: #fff;
      .title {
        font-size: rem(48); 
        font-weight: 400;
        color: #282828;
      }
      .article-time {
        font-size: rem(24);
        font-weight: 400;
        color: #808080;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    #article {
      margin:  0 .575rem;
      padding: .5rem 0;
      .title {
        font-size: .48rem;
        font-weight: 400;
        color: #282828;
      }
      .article-time {
        font-size: .24rem;
        font-weight: 400;
        color: #808080;
      }
    }
  }
</style>
